import { api, auth } from '@/f1/service';
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/f1/custom';
import _ from 'lodash'
import Language from './language';
import RuleCountry from '@/f1/views/WebCastle/agent/Agent.Country.i18n'
// import ruleI18n from '../rule.i18n' // 정책 번영 파일 추가
import reg from '@/f1/reg'
import Multiselect from 'vue-multiselect'
import 'flag-icon-css/css/flag-icon.css';
import Bell from 'vue-notification-bell'
import Detail from '../Log.Detail.i18n';
import punycode from 'punycode/'
import { Switch as cSwitch } from '@coreui/vue'
import codes from '@/f1/codes';

//restful api
import { webcastle_v2 as wc } from '@/f1/service/api';

//i18n_data
import _i18n_data from './i18n_data'
import i18n_data from '@/component/i18n_data';

// 임시 탐지 메세지 i18n
// const temp_i18n = {
//   'Country detected of user policy' : '사용자 정책의 국가 IP 기반 탐지',
//   'IPAddress detected of user policy' : '사용자 정책의 IP 주소 탐지',
//   'Host detected of user policy' : '호스트가 사용자 정책 탐지',
//   'Path detected of user policy' : '사용자 정책의 경로 탐지',
//   'Parameter detected of user policy' : '사용자 정책의 매개 변수 탐지',
// }

const default_opt = (is_default=true) => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv : false,
  created_at_ed : is_default ? moment().add(1, 'day') : '',
  created_at_sd : is_default ? moment().add(-1, 'day') : '',
});

export default {
  props : ['only_view', 'auto_refresh', 'agent_id_list', 'agent_id', 'summary', 'custom_style', 'custom_title', 'enable_paging', 'show_count', 'dc'],
  data: () => {
    return {
      summary_i18n : {
        EN : [],
        KO : []
      },
      // temp_i18n,
      loading : false,
      codes,
      moment,
      log_id : 0,
      is_half_mode : false,
      country_code : [],
      use_geoip : true,
      info_xff : false,
      // ruleI18n,
      extra : false,
      th : undefined,
      custom,
      show: true,
      auth : auth,
      so : default_opt(),
      sync : { interval : 15, run : false },
      selected : [],
      options: [],
      agent_list : [],
      agent : undefined,
      max_width : 1700,
      geo_reset : false,
      date_check: undefined,
      year_modal : false,
      date_modal : false,
      downloading: false,
    }
  },
  watch: {
    geo_reset(){
      return this.geo_reset
    }
  },
  components: { Language, DatePicker, Multiselect, RuleCountry, Bell, Detail, cSwitch },
  computed: {
    can_split_view: function() { return window.innerWidth > this.max_width },
    id : function() { return this.log_id; },
    startRow : function() {
      return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage;
    },
    fields() {
      return _.map(_i18n_data.i18n_fields[this.i18n || 'EN'], f => {
        if(f.option <= -1) {
          if(this.only_view != true) { return f }
          else if(this.summary != true) { return f }
        }
        else if(_.indexOf(this.selected, f.option) > -1 || f.option < 1) {
          return f
        }
      })
    },
    temp_i18n(){
      // console.log(i18n_data.temp_i18n[this.i18n])
      return i18n_data.temp_i18n[this.i18n]
    }
  },
  methods: {
    base64encode(x) { return window.btoa(encodeURIComponent(x)) },
    base64decode(x) { return decodeURIComponent(window.atob(x)) },
    set_flag(x) { return x ? `flag-icon flag-icon-${x.toLowerCase()}` : '' },
    download() {

      if(this.downloading) { return; }
      this.downloading = true;
      // 향후 엑셀 다운로드로 변경 필요
      let start_date = this.so.created_at_sd && moment(this.so.created_at_sd)
      let range = moment.duration((this.so.created_at_ed && moment(this.so.created_at_ed)).diff(start_date)).asMonths()
      // console.log('range month is', range)

      if(range > 6) { return this.$toastr.w(`${_i18n_data._i18n_warning.range_check[this.i18n]}`) }
      // 다운로드의 경우 3개월 단위로만 다운로드가 가능해야 함

      let search = this.search_option({}, true);
      // api.webcastle.WebCastle(Object.assign({}, search, { target : 'log', cmd : 'download' })).then(rs => {
      wc.detect.download(Object.assign({}, search)).then(rs => {
        if(!rs.body) { return this.$toastr.w(`${i18n_data._i18n_warning.data_check[this.i18n]}`) }

        // "Agent", "Agent ip", "DateTime(UTC)", "target", "host", "m_id", "message", "severity", "method", "protocol", "attacker", "country", "request", "response(block)"

        var blob = new Blob(["\ufeff"].concat(_.map(rs.body, x => {

          // console.log(index, x[12])
          try {
            if(x[6] != 'message') {
              x[6] = x[6][this.i18n].desc.replace(/,/, ' and ')
              // let msg = _.minBy(this.base64decode(x[6]).messages, z => z.details.severity)

              // x[6] = `"${x[6].replace(/"/g, '""')}"` // json 데이터 이슈
            }

            if(x[12] != 'request') {
              // request 부분 공격 부분이 잘못 필터링 됨
              x[12] = `"${x[12].replace(/"/g, '""')}"` // json 데이터 이슈
            }

            return x.concat('\r')
          } catch (e) {
            console.log(e)
          }
        })));
        let link = document.createElement('a')
        link.style.visibility = 'hidden';
        link.href = window.URL.createObjectURL(blob)
        link.download = 'WebCastle_detect_log.csv'
        link.click()

      }).catch(error => {
        console.error(error)
        this.$toastr.w(`${_i18n_data._i18n_error.download_failed[this.i18n]}`)
      }).finally(() => {
        this.downloading = false;
      })
    },
    add_country (newTag) { this.country_list.push(newTag) && this.country.push(newTag.agent_id) },
    add_tag (newTag) { this.agent_list.push(newTag) && this.agent.push(newTag.agent_id) },
    reload() { this.$refs && this.$refs._wc_log_list ? this.$refs._wc_log_list.refresh() : '' },
    is_block(messages) {
      return !_.startsWith(messages.toLowerCase(), 'detectiononly')
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        // this.so.opt['paid_at_ed'] = moment().add(1, "day").startOf('d');
        // this.so.opt['refund_at_ed'] = moment().add(1, "day").startOf('d');
        // this.so.opt['match_type'] = 'and';
        this.so.opt['remote_addr_check'] = false;
        this.so.opt['target_check'] = false;
        this.so.opt['message_check'] = false;
        this.so.opt['xff_check'] = false;
        this.so.opt['match_type'] = 'and';
        this.so.opt['method'] = ''
        this.so.opt['is_block'] = ''
        this.so.sv = '';
      } else { return } //this.reset(); }
    },
    autoSize : function() { return Number(window.innerWidth / 100) * 2 },
    reset() { this.so = default_opt(); this.geo_reset=true; this.reload(); },
    toggle() {
      this.sync.run = !this.sync.run;
      console.log(this.loading, this.sync.run)
      localStorage.setItem('uwss_webcastle_detect_auto_sync', this.sync.run)
      console.log(localStorage.getItem('uwss_webcastle_detect_auto_sync'))
      this.refresh();
    },
    refresh() {
      if(this.sync.run) {
        this.$refs && this.$refs._wc_log_list ? this.$refs._wc_log_list.refresh() : ''
        console.log('refresh list')
      }
      clearTimeout(this.th)
      this.th = undefined
      this.th = setTimeout(this.refresh, 1000 * this.sync.interval)
    },
    getRowCount () { return this.so.totalRows || 0; },
    getItems: function(ctx) { return this.load(ctx); },
    getAgentList: function() {
      if(this.only_view == true) { return console.log('is only view') }

      // api.webcastle.WebCastle({ target : 'agent', cmd : 'list.info' }).then(rs => {
      wc.agent.info().then(rs => {
        this.agent_list = []
        rs.body ? rs.body.forEach(agent => this.agent_list.push(agent)) : ''

      }).catch(error => console.error(error))
    },
    set_op(k, v, op=undefined) {
      if(op) { return { name : k, value : v, op : op }; }
      else if(k.endsWith('_check')) { return '' }

      v = v.trim()

      switch (k) {

        // case 'uri' : return { name : 'uri', value : `%${v}%`, op : 'like'};
        case 'method' : return { name : 'method', value : v, op : '='};
        case 'is_block' :
          if(!v) { return '' }
          return { name : 'is_block', value : v == 'false' ? false : true, op : '='};
        case 'm_id' : return { name : 'm_sub_id', value : v ? Number(v) : '', op : '='};
        case 'm_line' : return { name : 'm_line', value : Number(v), op : '='};
        case 'created_at_sd' : return { name: 'created_at', value: moment(v).valueOf(), op: '>=' };
        case 'created_at_ed' : return { name: 'created_at', value: moment(v).add(1, 'd').valueOf(), op: '<' };
        case 'last_visit_sd' : return { name: 'last_visit', value: moment(v).valueOf(), op: '>=' };
        case 'last_visit_ed' : return { name: 'last_visit', value: moment(v).add(1, 'd').valueOf(), op: '<=' };

        // case 'uri' : return;
        case 'xff':
          if(this.so.opt['xff'] && !reg.ip4.test(this.so.opt['xff'])) { return this.$toastr.w('XFF is not ip format') }

          if(this.so.opt.xff_check) {
            if(!v) { return { msg : 'check attacker search option'} }
            // if(!reg.ip4.test(v)) { return { msg : 'XFF is not ip format'} }
            return { name : 'headers', value : `%X-Forwarded-For: ${this.so.opt['xff']}%`, op : 'not like' }
            // return { name : 'headers', value : [v], op : 'not in' }
          } else {
            return { name : 'headers', value : `%X-Forwarded-For: ${this.so.opt['xff']}%`, op : 'like' }
            // return { name : 'headers', value : `%${v}%`, op : 'like' }
          }

        case 'headers':
          if(!v) { return '' }
          return { name : 'headers', value : `%${v}%`, op : 'like' }

        case 'remote_addr':
          if(this.so.opt.remote_addr_check) {
            if(!v) { return { msg : 'check attacker search option'} }
            return { name : 'remote_addr', value : [v], op : 'not in'} ;
          } else {
            return { name : 'remote_addr', value : v, op : '=' }
          }
        case 'target':
          if(this.so.opt.target_check) {
            if(!v) { return { msg : 'check Victim search option'} }
            return { name : 'target', value : [v], op : 'not in' }
          } else {
            return { name : 'target', value : v, op : '=' }
          }

        case 'message':
          // console.log("message")
          // 메세지의 경우, 룰 아이디로 치환하여 검색

          return _.map(_.filter(this.summary_i18n[this.i18n || 'EN'], s => {
            console.log("xxx", s)
            // console.log('s.msg.desc.indexOf(v) > -1 || s.msg.detail.indexOf(v) > -1', s.msg.desc.indexOf(v) > -1 || s.msg.detail.indexOf(v) > -1)
            return s.msg.desc.indexOf(v) > -1 || s.msg.detail.indexOf(v) > -1 || s.rule_id.indexOf(v) > -1
          }), m => {
            return { name : 'm_sub_id', value : Number(m.rule_id), op : '=' }
          })

          //Todo
          //제외 조건 설정이 되어있지않음
          //기본 조건이 OR 조건으로 현재 and 가 아닐경우만 성공
          // if(this.so.opt.message_check){  //제외 조건일시
          //   return _.map(_.filter(this.summary_i18n[this.i18n || 'EN'], s => {
          //     // console.log("xxx", s)
          //     // console.log('s.msg.desc.indexOf(v) > -1 || s.msg.detail.indexOf(v) > -1', s.msg.desc.indexOf(v) > -1 || s.msg.detail.indexOf(v) > -1)
          //     return s.msg.desc.indexOf(v) > -1 || s.msg.detail.indexOf(v) > -1 || s.rule_id.indexOf(v) > -1
          //   }), m => {
          //     return { name : 'm_sub_id', value : Number(m.rule_id), op : 'not like' }, { name : 'm_id', value : Number(m.rule_id), op : 'not like' }
          //   })
          // }else{  //아닐 경우
          //   return _.map(_.filter(this.summary_i18n[this.i18n || 'EN'], s => {
          //     // console.log("xxx", s)
          //     // console.log('s.msg.desc.indexOf(v) > -1 || s.msg.detail.indexOf(v) > -1', s.msg.desc.indexOf(v) > -1 || s.msg.detail.indexOf(v) > -1)
          //     return s.msg.desc.indexOf(v) > -1 || s.msg.detail.indexOf(v) > -1 || s.rule_id.indexOf(v) > -1
          //   }), m => {
          //     return { name : 'm_sub_id', value : Number(m.rule_id), op : '=' }
          //   })
          // }

          // return _.map(_.filter(this.summary_i18n[this.i18n || 'EN'], s => {
          //   // console.log('s.msg.desc.indexOf(v) > -1 || s.msg.detail.indexOf(v) > -1', s.msg.desc.indexOf(v) > -1 || s.msg.detail.indexOf(v) > -1)
          //   return s.msg.desc.indexOf(v) > -1 || s.msg.detail.indexOf(v) > -1
          // }), m => {
          //   return { name : 'm_id', value : Number(s.rule_id), op : '=' }
          // })

        case 'uri':
          if(this.so.opt.uri_check) {
            if(!this.so.opt['uri']) { return { msg : `${_i18n_data._i18n_warning.search_option_3[this.i18n]}`} }
            return { name : 'uri', value : `%${this.so.opt['uri']}%`, op : 'not like' }
          } else {
            return { name : 'uri', value : `%${v}%`, op : 'like' }
          }
        default:
          console.log('default', k, v, op)
          if(v === "false" || v === "true") { return { name : k, value : v === "false" ? false : true, op : '=' }  }
          return { name : k, value : `%${v}%`, op : 'like' }
      }
    },
    search_option(ctx = {}, is_range_foramt=false) {
      let so = {
        ok : ctx.sortBy,
        // od : ctx.sortDesc ? 'd' : 'a',
        pg : ctx.currentPage || this.so.currentPage || 1,
        pc : this.show_count && this.show_count > 0 ? this.show_count : (ctx.perPage || this.so.perPage || 10),
        sk : this.so.sk,
        sv : this.so.sv,
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {},
        // target : 'log', cmd : 'list'
      }
      var search = { limit: so.pc, offset: (so.pg - 1) * so.pc, target : so.target, cmd : so.cmd, body: { and: [], or: [], sort: [] } };

      // set sort
      if(so.sortBy) { search.body.sort = [ { name : so.sortBy, op : ctx.sortDesc && 'desc' } ]; }
      if(!is_range_foramt) { search.body.sort.push({ name : 'id', op : 'desc'}) }

      // 모듈로 에이전트 선택할 경우
      if(this.agent_id_list) {
        for (let i = 0; i < this.agent_id_list.length; i++) {
          let id = typeof this.agent_id_list[i] == 'object' ? this.agent_id_list[i].id : this.agent_id_list[i]
          id ? search.body.or.push({ name : 'agent_id', value : id, op : '='}) : ''
        }
      }

      // 목록에서 에이전트 선택했을 경우
      if(this.agent) {
        for (let i = 0; i < this.agent.length; i++) {
          search.body.or.push({ name : 'agent_id', value : this.agent[i].agent_id, op : '='})
        }
      }

      if(this.agent_id != undefined && this.agent_id > 0) {
        search.body.and.push({ name : 'agent_id', value : this.agent_id, op : '='})
      }

      if(this.so.sk && (this.so.sv || '').trim()) {
        let cond = this.set_op(this.so.sk, this.so.sv)

        // or 검색
        if(this.so.sk == 'message') {
          console.log('cond', 'message', cond)
          Array.isArray(cond) ? cond.forEach(x => search.body.or.push(x)) : search.body.or.push(cond)
        } else {
          Array.isArray(cond) ? cond.forEach(x => search.body.and.push(x)) : search.body.and.push(cond)
        }

      }
      if(this.so.created_at_ed) { search.body.and.push(this.set_op('created_at', moment(this.so.created_at_ed).add(1, 'd').format('YYYY-MM-DD'), '<=')) }
      if(this.so.created_at_sd) { search.body.and.push(this.set_op('created_at', moment(this.so.created_at_sd).format('YYYY-MM-DD'), '>=')) }

      if(this.so.adv && this.so.opt) {
        // 국가를 지정했을 경우
        if(this.country_code) {
          // console.log('country_code', this.country_code.length)
          for (let i = 0; i < this.country_code.length; i++) {
            search.body.or.push({ name : 'country', value : this.country_code[i].policy, op : '='})
          }
        }

        var k = Object.keys(this.so.opt)


        for (let i = 0; i < k.length; i++) {
          console.log(k[i], 'value', this.so.opt[k[i]])

          if(k[i] == 'match_type') { continue; }
          let cond = this.set_op(k[i], this.so.opt[k[i]]);

          if(Array.isArray(cond)) {
            cond.forEach(c => {
              if(!c || c.value == '%%' || c.value === '') { return; }
              else { this.so.opt['match_type'] == "and" ? search.body.and.push(c) : search.body.or.push(c) }
            })
            continue
          }
          if(cond.msg) { return this.$toastr.w(cond.msg) }
          else if(!cond || cond.value == '%%' || cond.value === '') { continue; }
          else { this.so.opt['match_type'] == "and" ? search.body.and.push(cond) : search.body.or.push(cond) }
        }
      }

      return search
    },
    async get_summary_i18n() {
      try {
        // let rs = await api.webcastle.WebCastle({ target : 'policy', cmd : 'summary.i18n', body : { ts : moment().valueOf() } })
        let rs = await wc.policy.summary({ ts : moment().valueOf() })
        if(rs.error) { return }

        Object.keys(rs.body).forEach(k => {
          // console.log('rs.body[k]', rs.body[k])
          Object.keys(rs.body[k]).forEach(rule_id => {
            this.summary_i18n.EN.push({ msg : rs.body[k][rule_id].i18n.EN, rule_id : rule_id })
            this.summary_i18n.KO.push({ msg : rs.body[k][rule_id].i18n.KO, rule_id : rule_id })
            // console.log('rs.body[k]', rs.body[k][rule_id])
          })
        })
      } catch (e) { console.log(e) }
    },
    load(ctx = {}) {
      try {
        clearTimeout(this.th)
        this.loading = true
        let search = this.search_option(ctx);
        this.geo_reset = false;

        if((!this.so.created_at_sd || !this.so.created_at_ed) && this.dc == undefined){
          this.date_modal = true;
          return this.date_modal
        }

        // 조회 기간 최대 1년
        this.date_check = this.checkdate();
        if(this.date_check > 365){
          this.year_modal = true;

          return this.year_modal
        }

        // return api.webcastle.WebCastle(search).then(rs => {
        return wc.detect.list(search).then(rs => {
          this.so.totalRows = rs.total;
          this.options = []
          _i18n_data.i18n_fields[this.i18n || 'EN'].forEach(r => {
              if(r.option < 1) { return }
              this.options.push({ text: r.label, value: r.option })
            });

          if(rs.body && rs.body.length > 0) {

            return _.map(rs.body, r => {
              // if(!r.title && !r.title_i18n) {
                try { r.message && typeof '' == typeof r.message ? JSON.parse(r.message) : r.message }
                catch (e) {
                  console.log(r.message)
                  console.log("json parser failed");
                  r.is_failed = true;
                  return r;
                }
              // }


              // 메세지 앞에 탐지한 구문이 있을 경우, 탐지만으로 설정, 패턴 N 개 매칭으로 인한 코드 추가
              // r.detect_cnt = _.filter(r.message.messages, x => _.startsWith(x.message.toLowerCase(), '[detectiononly]')).length
              // r.block_cnt = r.message.messages.length - r.detect_cnt
              // r.summary = _.minBy(r.message.messages, function(x) { return Number(x.details.severity) })

              _.forEach(r.headers ? r.headers.split('\n') : [], line => {
                let ip = line.replace(/(x-forwarded-for:| )/ig, '')
                _.startsWith(line.toLowerCase(), 'x-forwarded-for') && reg.ip4.test(ip) ? (r.xff = ip) : ''
              })

              // https://github.com/mathiasbynens/punycode.js
              // 기본 라이브러리 punycode 는 사용 불가
              if(_.startsWith(r.target, 'xn--')) { r.target = punycode.toUnicode(r.target) }
              if(_.startsWith(r.host, 'xn--')) { r.host = punycode.toUnicode(r.host) }

              return r
            })
          }

          return rs.body;
        }).catch(e => {
          console.log(e)
          this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` : e.data.message || e.data.title ? e.data.title : e.statusText)
        }).finally(() => {
          this.loading = false
          this.th = setTimeout(this.refresh, 1000 * this.sync.interval)
        });
      } catch (e) {
        console.log(e)
      }
    },
    // pause: function() { this.sync.run = !this.sync.run; this.refresh(); },
    // start: function() { this.sync.run = !this.sync.run; this.refresh(); },
    detail: function(item) {
      if(this.agent_id > 0) { return this.$parent.$emit('detail', item.id) }

      if(!this.is_half_mode) {
        console.log(item); this.$router.push(`log/${item.id}`);
        return
      }

      this.log_id = item.id
    },
    checkdate(){  //최대기간 설정
      let sd = moment(this.so.created_at_sd)
      let ed = moment(this.so.created_at_ed)

      let check_date = ed.diff(sd, 'day');
      return check_date
    }
  },
  created: function() {  console.log('webcastle', 'log.vue', 'created'); },
  destroyed: function() { console.log('webcastle', 'log.vue', 'destroyed'); clearTimeout(this.th); this.th = undefined},
  mounted: function() {
    console.log('webcastle', 'log.vue', 'mounted');
    this.getAgentList()
    this.so = default_opt(this.agent_id > 0 ? false : true)
    console.log("localStorage.getItem('uwss_webcastle_detect_auto_sync')", localStorage.getItem('uwss_webcastle_detect_auto_sync'))
    this.sync.run = localStorage.getItem('uwss_webcastle_detect_auto_sync') ? (localStorage.getItem('uwss_webcastle_detect_auto_sync') == 'true' ? true : false) : this.sync.run
    this.sync.run ? this.th = setTimeout(this.refresh, 1000 * this.sync.interval) : ''
    this.get_summary_i18n()

  },
}
